
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/what-is-port-drayage",
      function () {
        return require("private-next-pages/content/what-is-port-drayage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/what-is-port-drayage"])
      });
    }
  